import type { SupportedCountries } from "@/lib/locale/country";

export const FOOD_SUPPORTED_COUNTRIES = ['US', 'CA'] as const satisfies SupportedCountries[]
